import React from "react";
import { cn } from "../../utils/cn";

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  helperText?: string;
  error?: boolean;
  className?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  helperText,
  error,
  className,
  disabled,
  ...props
}) => {
  const checkbox = (
    <input
      {...props}
      type="checkbox"
      disabled={disabled}
      className={cn(
        "cursor-pointer",
        disabled && "cursor-not-allowed opacity-60",
        error && "accent-red-500",
        className
      )}
    />
  );

  return (
    <div className="flex flex-col items-start space-y-1">
      {label ? (
        <label className="flex items-center gap-2 text-sm text-gray-700">
          {checkbox}
          <span>{label}</span>
        </label>
      ) : (
        checkbox
      )}
      {helperText && (
        <span className={`text-xs ${error ? "text-red-500" : "text-gray-500"}`}>
          {helperText}
        </span>
      )}
    </div>
  );
};

export default Checkbox;
